/** `utm_medium` values (lower-cased) that mark paid traffic, beside the Google Ads click ids. */
const PAID_UTM_MEDIUMS = new Set([
    'cpc',
    'ppc',
    'paid',
    'paid-search',
    'paid_search',
    'paidsearch',
    'paid-social',
    'paid_social',
    'paidsocial',
    'display',
    'cpm',
]);
const AUDIENCE_SLUGS = {
    advocate: 'advocates',
    advocates: 'advocates',
    attorney: 'attorneys',
    attorneys: 'attorneys',
    'law-firm': 'law-firms',
    'law-firms': 'law-firms',
};
/** The arrival of a visit with no campaign attribution: every field at its `none` value. */
export const NO_UI_ARRIVAL = Object.freeze({ cta: 'none', audience: 'none', channel: 'none' });
/**
 * The closed arrival triple for a parsed campaign attribution: the signup button the visit
 * came from, the landing audience and the traffic channel. Any value outside the closed sets
 * becomes `other` (audience) or `none`, so a URL parameter can never put free text in an event.
 */
export function uiArrivalOf(attribution) {
    if (!attribution)
        return NO_UI_ARRIVAL;
    const audience = attribution.audience === undefined ? 'none' : (AUDIENCE_SLUGS[attribution.audience.toLowerCase()] ?? 'other');
    const isPaid = attribution.gclid !== undefined ||
        attribution.gbraid !== undefined ||
        attribution.wbraid !== undefined ||
        (attribution.utmMedium !== undefined && PAID_UTM_MEDIUMS.has(attribution.utmMedium.toLowerCase()));
    const hasUtm = [
        attribution.utmSource,
        attribution.utmMedium,
        attribution.utmCampaign,
        attribution.utmTerm,
        attribution.utmContent,
    ].some((value) => value !== undefined);
    return {
        cta: attribution.cta ?? 'none',
        audience,
        channel: isPaid ? 'paid' : hasUtm ? 'campaign' : 'none',
    };
}
